import React, {useMemo} from 'react';
import {uniq} from 'lodash';
import {TextAutoComplete} from '../../../componentsLib/Basic';
import {HoopsPropTypes} from '../../../componentsLib';
import {sortSizes} from '../../../utils';

export function VariantSizeList({item}) {
  const sizes = useMemo(() => {
    if (!item.color) {
      return item.product.sizes;
    }
    const unsortedSizes = item.product.variants
      .filter((variant) => variant.color === item.color).map((v) => v.size);
    return sortSizes(uniq(unsortedSizes));
  }, [item.color, item.product.sizes, item.product.variants]);

  return (
    <TextAutoComplete
      value={item.size}
      allowAnyValue
      options={sizes}
      emptyList={'No sizes available'}
      onChange={item.setSize}
    />
  );
}

VariantSizeList.propTypes = {item: HoopsPropTypes.object};
